import ReactGA from 'react-ga4';
import { useEffect } from 'react';
////////////////////////////////////////////////////////////////////
import { BackButton, GroupsGrid } from '@/app/shared/components';
import { useCustomSelector } from '@/core/redux/hooks';

/**
 * Component for rendering a grid of collection groups.
 *
 * @remarks
 * This component renders a grid of collection groups, along with a back button
 * and a title. It also sends a ReactGA event when mounted.
 *
 * @returns A JSX element containing the collection groups grid.
 */
const GroupsCollections: React.FC = () => {
	/*********************
	// #region Redux
	**********************/
	const { collections } = useCustomSelector((state) => state.collections);

	/*********************
	// #region Observables
	**********************/
	useEffect(() => {
		ReactGA.send({
			hitType: 'pageview',
			page: '/collections',
			title: 'Collections',
		});
	}, []);

	/*********************
	// #region Template
	**********************/
	return (
		<>
			<div className="flex flex-col pt-8 gap-4 mx-4 pb-8">
				<BackButton />
				<h2 className="text-center text-2xl font-bold">Collections</h2>
				<div className="min-h-[162px]">
					<img
						className="mx-auto  border-none"
						src={process.env.VITE_OPEN_GIFT_IMAGE}
						alt={'Gift'}
					/>
				</div>
			</div>
			<GroupsGrid groups={collections} />
		</>
	);
};

export default GroupsCollections;
